export default __webpack_public_path__ + "static/media/skype-logo.b1687418.png";